import { Component } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { getLocalStorage, setLocalStorage } from 'npx-arc-ui/utils';
import { TourController, TourStep } from 'src/assets/js/Tour/Tour';
import Storage from 'src/app/Models/Base/storage';
import Rutas from 'src/app/Models/Base/rutas';
import { Router } from '@angular/router';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { OtpComponent } from 'npx-arc-ui/otp-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
enum Data{
  CORREO = 1,
  QR,
  SMS
}

enum Tour{
  STEP_ONE = 'step1'
}

@Component({
  selector: 'app-dobule-factor',
  templateUrl: './dobule-factor.component.html',
  styleUrls: ['./dobule-factor.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , MatInputModule
    , MatFormFieldModule
    , MatSelectModule
    , FormsModule
    , ReactiveFormsModule
    , OtpComponent
  ]
})
export class DobuleFactorComponent{
  selectedValue: string = '';
  codeSet: string = '';
  codeSelected: string = '';
  step1 = Tour.STEP_ONE;
  public tour: TourController;
  isTwoFactorEnabled = false;
  step = 0;
  largoCodigo: number = 5;
  loading = false;
  private token: string = '';

  countdown: number = 30;
  interval: any = null;
  message: string = '';
  isCountingDown: boolean = false;
  maxRetriesReached: boolean = false;
  maxVerifyRetriesReached: boolean = false;
  MensajeConteo: string = 'Reenviar código: (' + this.countdown + ' segundos).';
  codigoCtrl = new FormControl('', [Validators.required]);

  validationOTPCode(): boolean {
    if (this.maxVerifyRetriesReached) return true;
    const { value: codigo } = this.codigoCtrl;
    const c = [...String(codigo)];
    if (c.length < 5) return true;
    return false;
  }

  constructor(
    public appStateService: AppStateService
    , private router: Router
  ) {
    this.tour = new TourController();
    const 
    navigation = this.router.getCurrentNavigation(),
    state = navigation?.extras.state;
    this.token = state?.state?.token || '';
    if(!appStateService.LoginResult){
      this.appStateService.router.navigate([Rutas.LOGIN])
    }

    // Resetear contador de intentos al entrar a la página
    setLocalStorage(Storage.N_INTENTOS, '0');
    setLocalStorage('NVerifyIntentos', '0');
  }

  get isQR(): boolean{
    return Number(this.codeSet) === Data.QR;
  }

  get isEmail(): boolean {
    return Number(this.codeSet) === Data.CORREO;
  }
  
  get isSMS(): boolean {
    return Number(this.codeSet) === Data.SMS;
  }

  onSelect({value}: MatSelectChange){
    this.largoCodigo = Number(value) === Data.QR ? 6 : 5;
  }

  SenCode() {
    this.appStateService.UserService
    .SendCode(this.codeSet, '', this.token)
    .subscribe(({success}) =>{
      if(success){
        this.step++;
      }
    })
  }

  VerifyCode() {
    const verifyIntentos = Number(getLocalStorage<any>('NVerifyIntentos')?.data) || 0;
    if (verifyIntentos >= 6) {
      this.maxVerifyRetriesReached = true;
      return;
    }

    this.appStateService.UserService
    .VerifyCode(String(this.codigoCtrl.value), this.codeSet, 0, this.token)
    .subscribe({
      next: ({success}) => {
        if(success){
          this.appStateService.onPostLogin();
        }
      },
      error: (err) => {
        const intentosActuales = Number(getLocalStorage<any>('NVerifyIntentos')?.data) || 0;
        const nuevosIntentos = intentosActuales + 1;
        setLocalStorage('NVerifyIntentos', String(nuevosIntentos));
        if (nuevosIntentos >= 6) {
          this.maxVerifyRetriesReached = true;
        }
      }
    });
  }

  startCountdown(event: Event) {
    // Si el contador está corriendo, bloquear la acción
    if (this.isCountingDown) {
      event.preventDefault();
      return;
    }

    const intentos = Number(getLocalStorage<any>(Storage.N_INTENTOS)?.data) || 0;

    if (intentos < 3) {
      setLocalStorage(Storage.N_INTENTOS, String(intentos + 1));
      this.countdown = 30;
      this.isCountingDown = true;

      this.appStateService.UserService
        .SendCode(this.codeSet, '', this.token)
        .subscribe();

      // Limpiar intervalo anterior si existe
      if (this.interval) {
        clearInterval(this.interval);
      }

      this.interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          this.MensajeConteo = 'Reenviar código: (' + this.countdown + ' segundos).';
        }
        if (this.countdown === 0) {
          clearInterval(this.interval);
          this.interval = null;
          this.isCountingDown = false;

          const intentosActuales = Number(getLocalStorage<any>(Storage.N_INTENTOS)?.data) || 0;
          if (intentosActuales >= 3) {
            this.maxRetriesReached = true;
            this.MensajeConteo = 'Has superado el máximo de intentos';
          } else {
            this.MensajeConteo = 'Reenviar código';
          }
        }
      }, 1000);
    } else {
      this.maxRetriesReached = true;
      this.MensajeConteo = 'Has superado el máximo de intentos';
    }
  }

  private onStartTour(){
    const steps: TourStep[] = [
      {
        element: `#${this.step1}`,
        title: 'Autenticación de doble factor',
        content:
          'La doble autenticación consiste en un código que se debe ingresar al momento de iniciar sesión, con el fin de proteger tu cuenta.',
      },
      {
        element: `#${this.step1}`,
        title: 'Autenticación de doble factor',
        content:
          'Recibirás un código dinámico en tu correo o algún otro medio de los que se ofrecen a continuación y al ingresarlo correctamente, podrás iniciar sesión en el Portal Defontana',
      },
    ];

    this.tour.onConfigTour(steps);
    this.tour.onStartTour();
  }
}
